export const TEMPLATES = {
    HS_GRAD: 'HS-GRAD',
    COL_GRAD_ANNC: 'COL-GRAD-ANNC',
    COL_GREG_PKG: 'COL-GREG-PKG'
}